import { FinanceAccountMoveMoneyLandingContainer } from '../../../../containers';

export const FinanceAccountMoveMoneyLanding = () => {
  return <FinanceAccountMoveMoneyLandingContainer />;
};
